module.exports = __webpack_public_path__ + "static/media/file-download.7a705f10.svg";